import cx from "classnames";
import { parseParagraphSize, parseTextAlignAttr } from "./helpers";
export const paragraphNodeSpec = {
    paragraph: {
        content: "inline*",
        group: "block",
        attrs: {
            textAlign: { default: "left" },
            size: { default: "medium" },
        },
        parseDOM: [
            {
                tag: "p",
                getAttrs: (node) => {
                    const element = node;
                    const attrs = {
                        textAlign: parseTextAlignAttr(element),
                        size: parseParagraphSize(element),
                    };
                    return attrs;
                },
            },
        ],
        toDOM: (node) => {
            const { textAlign, size } = node.attrs;
            const className = cx({
                [`align-${textAlign}`]: !!textAlign && textAlign !== "left",
                [`size-${size}`]: !!size && size !== "medium",
            });
            return ["p", className ? { class: className } : {}, 0];
        },
    },
};
